import axios from 'axios';

// Centralised Axios instance for all forum related API calls.
// If the API ever moves to another sub-domain or needs auth headers, edit only this file.
const forumApi = axios.create({
  baseURL: '/', // same origin; adjust if the backend is served elsewhere
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true // send cookies for Drupal sessions
});

// Generic error logging – each component may still handle the promise rejection.
forumApi.interceptors.response.use(
  response => response,
  error => {
    /* eslint-disable no-console */
    console.error('[Forum API]', error);
    return Promise.reject(error);
  }
);

export default forumApi; 